import Cart from "./cart"
import API from "../api"

(window as any).Cart = Cart;
(window as any).API = API;
(window as any).GA4Items = []

$(() => Cart.onPageLoad())